import { StyledLink } from 'baseui/link';
import { Notification } from 'baseui/notification';

export const UnsupportedBrowserBanner = () => (
  <Notification kind="negative" overrides={{ Body: { style: { width: 'auto', opacity: 1 } } }}>
    Your browser is outdated. Please{' '}
    <StyledLink href="https://browser-update.org/update.html">update your browser</StyledLink> to
    use this site.
  </Notification>
);
